<template>
  <v-container class="pa-0" fluid id="planner_joblistcontainer">


    <v-card class="rounded-0" style="z-index: 25;">
      <v-container class="pa-2">
        <v-row no-gutters align="center">

          <v-col cols="auto" class="pr-3">
            <v-btn outlined :disabled="!isFiltered" :color="'error'" small @click="clearFilters()">
              {{ $t('servicesystem.common_objects.commonterms.clear') }}
            </v-btn>
          </v-col>

          <v-col>
            <Searchfield v-model="jobSearchWord" />
          </v-col>

          <v-col cols="auto">
            <v-btn icon small class="mx-2" @click="openTrigger++">
              <v-icon>
                mdi-filter
              </v-icon>
            </v-btn>
          </v-col>

          <!-- 
          <v-col cols="auto">
            <v-btn icon small>
              <v-icon>
                mdi-sort
              </v-icon>
            </v-btn>
          </v-col>
          -->
        </v-row>

      </v-container>

      <SlottedDialog :externaltrigger="openTrigger" :title="$t('servicesystem.common_objects.job.list_filter')">
        <template v-slot:content>
          <v-container :key="clearFiltesTrigger">
            {{ $t("servicesystem.common_objects.job.list_filter_hint") }}
            <br> <br>
            <v-row no-gutters>
              <v-col>
                <QAutoComplete v-model="FilterStatus" :label="$t('servicesystem.common_objects.job.status')"
                  :list="statuses" :textkey="'Name'" :valuekey="'Id'" multiple :rules="[requiredRule]" externaledit
                  class="mb-3">
                  <template v-slot:item="{ data, item }">
                    <v-list-item-action>
                      <v-checkbox :input-value="data.attrs.inputValue"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      {{ item.Name }}
                    </v-list-item-content>
                    <v-list-item-icon class="mx-0 my-auto">
                      <CardBadge :color="'primary'" :count="item.Count" :index="0">
                      </CardBadge>
                      <CardBadge :color="'#4397E8'" :count="substatusCount(item.Id)" :index="1">
                      </CardBadge>
                    </v-list-item-icon>
                  </template>
                </QAutoComplete>

                <!-- 
                <QAutoComplete v-model="jobpriorityfilter" :label="$t('servicesystem.common_objects.job.priority')"
                  :list="jobPriorityList" :textkey="'Name'" :valuekey="'Id'" clearable multiple externaledit
                  class="mb-3">
                </QAutoComplete>
                <QAutoComplete v-model="jobtypefilter" :label="$t('servicesystem.common_objects.job.type')"
                  :list="jobTypeList" :textkey="'Name'" :valuekey="'Id'" clearable multiple externaledit class="mb-3">
                </QAutoComplete>
                -->
                <v-row no-gutters class="pt-3">
                  <v-col cols="0">
                    <DepartmentSelect v-model="departmentFilter" clearable multiple externaledit class="mb-3 mt-0">
                    </DepartmentSelect>
                  </v-col>
                  <v-col cols="auto" class="pt-3">
                    <v-btn icon small :color="departmentfilterIsDefault ? 'primary' : 'disabled'"
                      @click="setDeparmentGlobalPref()">
                      <v-icon>mdi-star</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </SlottedDialog>
    </v-card>


    <QScroll :list="jobs" :height="vertical ? 'calc(100vh - 195px)' : '222px'"
      :minheight="vertical ? 'calc(100vh - 200px)' : '222px'" :horizontal="!vertical"
      :loading="$store.getters['plannerstore/UnplannedJobListLoading'] && (!jobs || !jobs.length)"
      :skeletonloading="true">

      <template v-slot:list-item="{ item, index }">
        <div class="br-draggable ignoreodd" :data-index="index" :data-jobid="item.Id" :data-subject="item.DisplayName"
          :data-estimatedtime="item.EstimatedTime">
          <v-card v-if="JobListItemMode == 'card'" class="ma-2 pa-3">
            <b>
              <router-link :to="{ name: 'ViewJob', params: { filter: 'my', jobId: item.Id } }" class="minimalLink"
                style="user-drag: none;">{{ item.DisplayName }}</router-link>
              <br>
            </b>
            <v-chip x-small class="my-1" style="border-radius: 4px;">{{ item.JobTypeName }}</v-chip>
            <p v-if="item.DeliveryAddress" class="my-1">
              <v-icon size="17">mdi-map-marker</v-icon>
              {{ [item.DeliveryAddress.Street, item.DeliveryAddress.City, item.DeliveryAddress.Zip,
              item.DeliveryAddress.Country].join(" ") }}
            </p>
            <div v-for="mj in item.Jobs" :key="mj.Id"
              style="font-size: 12px; display: -webkit-box; -webkit-line-clamp: 10; -webkit-box-orient: vertical; overflow: hidden;">
              <router-link :to="{ name: 'ViewMachine', params: { machineId: mj.MachineId } }" class="minimalLink"
                style="user-drag: none;">
                {{ mj.DisplayName }}
              </router-link>
              : {{ mj.CustomerComment }}
            </div>
          </v-card>
          <JobListItem2 v-else :jobItem="item" :selected="item.selected" :hover="item.hover" :showStatus="true"
            :showAddress="true" :draggable="false" :nav-disabled="true" @mouseover="hover(item)" @click="click">
          </JobListItem2>
        </div>
      </template>

      <template v-slot:skeleton-loader="{ index }">
        <v-card v-if="!vertical" class="mx-2 my-3 mb-5" max-width="200" min-width="200" height="190" elevation="0"
          :style="'opacity: ' + (10 - index) / 10 + ';'">
          <v-skeleton-loader height="190" type="list-item, divider, list-item,  list-item,  list-item">
          </v-skeleton-loader>
        </v-card>
        <v-card v-else class="py-3" elevation="0" :style="'opacity: ' + (10 - index) / 10 + ';'">
          <v-skeleton-loader type="list-item-avatar, list-item, divider">
          </v-skeleton-loader>
        </v-card>
      </template>

      <template v-slot:empty-list>
        <v-card height="222px" color="transparent" flat class="d-flex flex-column align- center justify-center">
          <v-icon v-text="'mdi-briefcase-remove'" class="mb-5" size="70" />
          <h3 class="useThemeTextColor mx-7 text-center"
            v-text="$t('servicesystem.common_objects.fallbackterms.no_unplanned_jobs')" />
        </v-card>
      </template>

    </QScroll>
    <v-divider />
    <div v-html="myStyle" />
  </v-container>
</template>


<script>
import CardBadge from "@/components/Buttons/CardBadge.vue";
//import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";
import JobListItem2 from "@/components/ListItems/JobListItem/JobListItem-nodevexpress.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
//import ListToolbar from "@/views/admin/machines/ListToolbar.vue";
import Searchfield from "@/views/layouts/SearchField.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import { debounce } from "debounce";

export default {
  name: "JobCardList",
  components: {
    //RefreshBtn,
    //ListToolbar,
    QScroll,
    CardBadge,
    JobListItem2,
    Searchfield,
    SlottedDialog,
    DepartmentSelect,
  },
  props: ["vertical"],

  data() {
    return {
      currentEstimatedTime: 1,
      draggingGroupName: "appointmentsGroup",

      sortablefields: [
        { key: "OrderId", type: "int", displayString: "servicesystem.common_objects.order.order_id" },
        { key: "StatusId", type: "int", displayString: "servicesystem.common_objects.job.status" },
        { key: "JobPriorityDueAfterHours", type: "int", displayString: "servicesystem.common_objects.job.priority" },
        { key: "JobTypeName", type: "string", displayString: "servicesystem.common_objects.job.type" },
        //{ key: "CreatedDate", type: "datetime", displayString: "servicesystem.common_objects.job.created" },
      ],
      filterablefields: [],
      openTrigger: 1,
      clearFiltesTrigger: 1,
    };
  },

  mounted() {
    this.getjobs();
    this.subscribe();
  },

  beforeDestroy() {
    this.unSubscribe();
  },


  methods: {
    subscribe() {
      this.$store.dispatch("NotificationStore/subscribe", [SRConst.EventKeys.JobChange, this.debounceRefresh]);
    },
    unSubscribe() {
      this.$store.dispatch("NotificationStore/unsubscribe", [SRConst.EventKeys.JobChange, this.debounceRefresh]);
    },

    click(item) {
      this.$emit("select", item)
    },
    hover(item) {
      this.jobs.forEach(e => {
        if (e.hover == true && e.Id != item.Id) {
          e.hover = false;
        }
      })
      item.hover = true
    },

    async getjobs() {
      await this.$store.dispatch("plannerstore/GetUnplannedJobs");
    },

    onListDragStart(e) {
      e.cancel = true;
    },

    clearFilters() {
      this.jobSearchWord = null;
      this.FilterStatus = [10];
      this.departmentFilter = null;
      this.clearFiltesTrigger++;
      this.debounceRefresh();
    },

    //debounce to avoid to many refreshes triggered by filter/menu changes
    debounceRefresh: debounce(function () {
      //console.log('debounceRefresh');
      this.getjobs();
    }, 700),

    substatusCount(parentStatusId) {
      var list = Object.assign([], this.$store.getters["LookUpStore/JobSubStatusListByParent"](parentStatusId));
      var count = 0;
      list.forEach((x) => {
        count += x.Count;
      });
      return count;
    },

    onItemDragStart(e) {
      const pageX = e.event.pageX;
      const pageY = e.event.pageY;
      e.element.style.position = 'fixed';
      e.element.style.left = `${pageX / 2}px`;
      e.element.style.top = `${pageY / 2}px`;
      this.currentEstimatedTime = e.fromData.EstimatedTime;
      e.itemData = e.fromData;
    },

    onItemDragEnd(e) {
      e.element.style.position = '';
      if (e.toData) {
        e.cancel = true;
      }
    },

    setDeparmentGlobalPref() {
      if (this.departmentfilterIsDefault) {
        this.globalPreferenceDeparmentFilter = null;
      }
      else {
        this.globalPreferenceDeparmentFilter = Object.assign([], this.departmentFilter);
      }
    },
  },

  computed: {
    isFiltered() {
      console.log('isFiltered', !this.SameValue(this.FilterStatus, [10]), this.jobSearchWord, !this.departmentfilterIsDefault);

      return !this.SameValue(this.FilterStatus, [10]) || this.jobSearchWord || !this.departmentfilterIsDefault;
    },

    jobs: {
      get() {
        return this.$store.getters["plannerstore/UnplannedJobList"];
      },
      set(update) {
        this.$store.dispatch("plannerstore/SetUnplannedJobsList", update);
      },
    },

    JobListItemMode() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerJobListItemMode");
    },

    FilterStatus: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListStatusFilterMultiple");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListStatusFilterMultiple", value: update });
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListSubStatusFilter", value: null });
        this.debounceRefresh();
      },
    },
    FilterSubStatus: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListSubStatusFilter");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListSubStatusFilter", value: update });
        this.debounceRefresh();
      },
    },

    jobpriorityfilter: {
      get() { return this.getQueryParam("filter-jobpriority", []); },
      set(update) { this.setQueryParam("filter-jobpriority", update); },
    },

    jobSearchWord: {
      get() {
        return this.$store.getters["plannerstore/SearchWord"];
      },
      set(update) {
        this.$store.dispatch("plannerstore/SetSearchWord", update);
        this.debounceRefresh();
      },
    },

    statuses() {
      var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
      var filteredstatuses = statuses.filter((y) => y.Id < 70);
      return filteredstatuses;
    },
    jobPriorityList() {
      var list = this.$store.getters["LookUpStore/JobPriorityList"];
      return list && list.length ? list : [];
    },
    jobTypeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },

    departmentFilter: {
      get() {
        var stored = this.$store.getters["prefrences/Prefrence"]("PlannerJobListDepartmentFilter");
        if ((!stored || !stored.length) && this.globalPreferenceDeparmentFilter) {
          return this.globalPreferenceDeparmentFilter;
        }
        else {
          return stored;
        }
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListDepartmentFilter", value: update });
        this.debounceRefresh();
      },
    },

    //default department filter from preference
    globalPreferenceDeparmentFilter: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("JobListFilterOrderDepartmentDefault");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "JobListFilterOrderDepartmentDefault", value: update });
      },
    },

    departmentfilterIsDefault() {
      return this.SameValue(this.departmentFilter, this.globalPreferenceDeparmentFilter);
    },

    //style applied to drag element to show its width representatively in the planner before dropping it.
    myStyle() {
      return `
      	<style>
        .dx-scheduler-date-table-droppable-cell::after {
          width: ` + (this.currentEstimatedTime * 4 * 30) + `px;
        }
        </style>
        `;
    },
  },

  watch: {
    globalPreferenceDeparmentFilter: function () {
      //update ui job counters with filter preference
      this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
    },
  },
};
</script>


<style lang="scss" scoped>
.minitoolbar {
  position: sticky;
  width: 100%;
  z-index: 4;
  //box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}

.joblist {
  display: flex;
  max-width: 100%;
  overflow-x: overlay !important;
  z-index: 5;
}

.joblist.vertical {
  flex-direction: column;
  align-items: center;
  overflow-y: overlay !important;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .joblist {
    overflow-x: auto !important;
  }

  .joblist.vertical {
    overflow-y: auto !important;
  }
}
</style>

<style lang="scss">
.minitoolbar.lowered,
.minitoolbar.lowered .v-toolbar__content {
  height: 41px !important;
}

.minimalLink {
  text-decoration: none;
}

.minimalLink:hover {
  text-decoration: underline;
}
</style>
